import { useMutation } from "@tanstack/react-query";
import { apiPost } from "@/lib/api-client";

export type ContactInquiryRequestType = "demo" | "general";

export interface ContactInquiryCreateRequest {
    full_name: string;
    work_email: string;
    company: string;
    request_type: ContactInquiryRequestType;
    message: string;
    privacy_consent: boolean;
    relationship_type?: string;
    source_page?: string;
}

export interface ContactInquiryCreateResponse {
    success: boolean;
    inquiry_id: string;
    message: string;
}

export function useCreateContactInquiry() {
    return useMutation({
        mutationFn: async (payload: ContactInquiryCreateRequest): Promise<ContactInquiryCreateResponse> => {
            return apiPost<ContactInquiryCreateResponse>("/contact-inquiries", payload, { requireAuth: false });
        },
    });
}
